import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import { useNavigate } from 'react-router-dom';
import {motion} from 'framer-motion'

const AboutBakery = () => {
    let navigate = useNavigate();
    
    return (
    <div className="app__bg app__wrapper section__padding" id="about">

      <div className="app__wrapper_img" style={{marginRight:'1rem'}}>
        <img src={images.about_image} alt="finus_img" />
      </div>

      <div className="app__wrapper_info">
        <SubHeading title="Welcome" />
        <h1 className="headtext__cormorant" style={{ marginBottom: '3rem' }}>About Dolci Paradise</h1>
        <div className="app__wrapper-content">
          <p className="p__opensans">Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Quis Pharetra Adipiscing Ultrices Vulputate Posuere Tristique. In Sed Odio Nec Aliquet Eu Proin Mauris Et.</p>
          {/* <p className="p__cormorant" style={{ color: '#894e3f', margin: '2rem 0' }}>Opening Hours</p>
          <p className="p__opensans">Mon - Fri: 10:00 am - 02:00 am</p>
          <p className="p__opensans">Sat - Sun: 10:00 am - 03:00 am</p> */}
        </div>
        <motion.button whileTap={{ scale: 0.9 }} type="button" className="custom__button" onClick={() => navigate('/about')} style={{ marginTop: '2rem' }}>Read more</motion.button>
      </div>

      
    </div>)
  
};

export default AboutBakery;